import React, { ReactChild } from 'react';

const IcGift: () => ReactChild = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <g id="Group_16547" data-name="Group 16547" transform="translate(13134 9046)">
      <path
        id="Path_8644"
        data-name="Path 8644"
        d="M19,7.25H16.435A2.709,2.709,0,0,0,16.75,6,2.752,2.752,0,0,0,14,3.25a2.724,2.724,0,0,0-1.709.612A3.24,3.24,0,1,0,6.77,7.25H5a2.75,2.75,0,0,0-.75,5.4V19A2.752,2.752,0,0,0,7,21.75H17A2.752,2.752,0,0,0,19.75,19V12.646A2.75,2.75,0,0,0,19,7.25m-5-2.5a1.25,1.25,0,0,1,0,2.5H12.75V6A1.252,1.252,0,0,1,14,4.75M7.75,5.5a1.75,1.75,0,0,1,3.5,0V7.25H9.5A1.752,1.752,0,0,1,7.75,5.5M5,11.25a1.25,1.25,0,0,1,0-2.5h6.25v2.5ZM5.75,19V12.75h5.5v7.5H7A1.252,1.252,0,0,1,5.75,19m12.5,0A1.252,1.252,0,0,1,17,20.25H12.75v-7.5h5.5ZM19,11.25H12.75V8.75H19a1.25,1.25,0,0,1,0,2.5"
        transform="translate(-13134 -9046)"
      />
      <rect
        id="Rectangle_6109"
        data-name="Rectangle 6109"
        width="24"
        height="24"
        transform="translate(-13134 -9046)"
        fill="none"
      />
    </g>
  </svg>
);

export default IcGift;
